/**
 * @file Layout.tsx
 *
 * @fileoverview Renders a wizard layout component.
 */
import React, { ReactNode } from 'react';
import { Branding } from '~/jobiqo/components/Branding';
import { PrivacyPolicyLink } from '~/jobiqo/components/PrivacyPolicyLink';
import Messages from '~/jobiqo/components/Messages';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { AlignedCenter } from '~/vcl/atoms/06-layout/01-alignment/01-align-center';
import { getFrontendTheme } from '~/jobiqo/utils/getFrontend';
import { HeaderWizardSlot } from '~/jobiqo/components/Slots/HeaderWizardSlot';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface WizardLayoutProps {
  /**
   * The contents for the page.
   */
  children: ReactNode;
  /**
   * the size for the container.
   *
   * @default "medium"
   */
  size?: 'small' | 'medium' | 'large' | 'xLarge';
  /**
   * The wizard steps.
   *
   */
  Steps: ReactNode;
}

export function WizardLayout({
  children,
  size = 'medium',
  Steps = null,
}: WizardLayoutProps) {
  const frontendConfig = useFrontendConfig();
  const frontendTheme = getFrontendTheme(frontendConfig);

  return (
    <main>
      <Main size={size}>
        <div>
          <HeaderWizardSlot />
        </div>
        <Spacing size="large" />
        <AlignedCenter>
          <Branding maxHeight={frontendTheme.logo.singlePageMaxHeight} />
        </AlignedCenter>
        <Spacing size="medium" />
      </Main>
      {Steps}
      <Spacing size="large" />
      <Main size={size}>
        <Spacing size="large" />
        <Messages size={size} />
        <Spacing size="large" />
        <div>{children}</div>
      </Main>
      <Spacing size="large" />
      <PrivacyPolicyLink />
      <Spacing size="medium" />
    </main>
  );
}
